/* unplugin-vue-components disabled */import { render } from "./dateEditor.vue?vue&type=template&id=226998bb"
import script from "./dateEditor.vue?vue&type=script&lang=js"
export * from "./dateEditor.vue?vue&type=script&lang=js"

import "./dateEditor.vue?vue&type=style&index=0&id=226998bb&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__